import React from 'react';
import CardItem from './CardItem';
import './Cards.css';
import { useLang } from '../i18n';

function Cards() {
  const { t } = useLang();
  return (
    <div className='cards'>
        <h1>{t('home.upcomingTitle')}</h1>
        <div className='cards__container'>
            <div className='cards__wrapper'>
                <ul className='cards__items'>
                    {/* Junior tournament hidden for now — keep for future reuse
                    <CardItem
                    src='images/junior.png'
                    text='SLOVAK JUNIOR Badminton Europe Junior circuit'
                    label='21-23rd November'
                    path='/junior'
                    />
                    */}
                    <CardItem
                    src='images/U15.png'
                    text={t('home.u15Card')}
                    label={t('home.labelUpcoming')}
                    path='/u15'
                    />
                    <CardItem
                    src='images/U17.png'
                    text={t('home.u17Card')}
                    label={t('home.eventDateShort')}
                    path='/u17'
                    />
                    <CardItem
                    src='images/U13.png'
                    text={t('home.u13Card')}
                    label={t('home.eventDateShort')}
                    path='/u13'
                    />
                </ul>
            </div>
        </div>
    </div>
  );
}

export default Cards;
